import classNames from 'classnames';
import { useCallback } from 'react';
import PropTypes from 'prop-types';

import styles from './_index.module.scss';

const ConceptImageList = ({ className, items, onOpen }) => {
  const handleImageLoad = useCallback((event) => {
    const image = event.currentTarget;
    const tile = image.closest(`.${styles['concept-image-tile']}`);
    if (!tile) return;
    tile.style.width = `${image.getBoundingClientRect().width}px`;
  }, []);

  if (!items?.length) return null;

  return (
    <div className={classNames(styles['concept-image-list'], className)}>
      {items.map((item, index) => (
        <button
          aria-label={`Open concept image for ${item.quotaGroupName || item.name || 'concept'}`}
          className={styles['concept-image-button']}
          key={item.id ?? item.name ?? item.src}
          onClick={() => onOpen(index)}
          type="button"
        >
          <span className={styles['concept-image-tile']}>
            {item.quotaGroupName && (
              <span className={styles['concept-image-header']}>
                {item.color && (
                  <span
                    className={styles['concept-image-dot']}
                    style={{ backgroundColor: item.color }}
                  />
                )}
                <span className={styles['concept-image-quota']}>{item.quotaGroupName}</span>
              </span>
            )}
            <img
              alt={item.alt}
              className={styles['concept-image']}
              onLoad={handleImageLoad}
              src={item.src}
            />
            <span className={styles['concept-image-text']}>{item.name}</span>
          </span>
        </button>
      ))}
    </div>
  );
};

ConceptImageList.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string.isRequired,
      color: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      quotaGroupName: PropTypes.string,
      src: PropTypes.string.isRequired,
    })
  ),
  onOpen: PropTypes.func.isRequired,
};

export default ConceptImageList;
